import "../../shimmer.css";

const GreenButton = (props) => {
  return (
    <button
      disabled={props.process} // Add the disabled attribute
      onClick={props.onClick}
      className="shadow-md w-full h-16  bg-green-500 hover:bg-green-500/90 text-white transition-colors duration-200 text-lg md:text-lg rounded relative animate-action-button-green"
    >
      {props.process && (
        <div className="w-full h-full absolute top-0 left-0 flex justify-center items-center bg-black/50 ">
          <div className="border-t border-white w-9 h-9 rounded-full animate-spin"></div>
        </div>
      )}
      {props.name}
    </button>
  );
};

export default GreenButton;
